{
  "title": "Settings",
  "tabs": {
    "provider": "Provider",
    "connection": "Connect",
    "appearance": "Look",
    "agent": "Agent",
    "features": "Feat.",
    "mcp": "MCP"
  },
  "appearance": {
    "themeHeading": "Theme",
    "themeLight": "Light",
    "themeDark": "Dark",
    "themeSystem": "System",
    "themeSystemHint": "System follows your OS-level light/dark preference.",
    "preferencesHeading": "Preferences",
    "compactDensity": "Compact density",
    "compactDensityHint": "Tighter spacing throughout the chat.",
    "soundOnComplete": "Sound on completion",
    "soundOnCompleteHint": "Play a soft chime when a run finishes.",
    "titleAnimation": "Title animation",
    "titleAnimationHint": "Show animated terminal title in the CLI.",
    "languageHeading": "Language",
    "languageLabel": "Interface language",
    "languageHint": "Changes only the interface text. Prompts, skills, and model output are not affected."
  },
  "model": {
    "heading": "Model",
    "loading": "Loading models...",
    "notFound": "No models found for this provider. The catalog might be empty or still loading.",
    "selectProviderFirst": "Select a provider first",
    "context": "{{count}}k context"
  },
  "connection": {
    "wsUrlLabel": "WebSocket Server URL",
    "wsUrlPlaceholder": "ws://localhost:3457",
    "wsUrlHint": "URL of the agent WebSocket server. The server runs alongside the CLI.",
    "startingHeading": "Starting the WebSocket Server",
    "startingBody": "Standalone: run ./dev.ps1 from the repo root, or set WS_HOST/WS_PORT before launching wstackui. Or alongside the CLI: wstack --webui."
  },
  "provider": {
    "subscriptionHeading": "Subscription login",
    "apiKeysHeading": "API key providers",
    "apiKeysBody": "Pick a provider from the catalog and add an API key, or manage saved providers.",
    "tabCatalog": "Catalog",
    "tabSaved": "Saved ({{count}})",
    "searchPlaceholder": "Search {{count}} providers (name / id / family)…",
    "loadingCatalog": "Loading catalog...",
    "noMatch": "No providers match \"{{query}}\".",
    "configured": "Configured",
    "reachable": "Reachable",
    "envVar": "ENV: {{var}}",
    "modelCount_one": "{{count}} model",
    "modelCount_other": "{{count}} models",
    "keyPlaceholder": "{{name}} API key",
    "orEnv": "Or set {{env}} in the environment instead.",
    "addApiKey": "Add API key",
    "manageKeys": "Manage your API keys and provider configurations",
    "addProvider": "Add Provider",
    "addCustomHeading": "Add Custom Provider",
    "localServers": "Local servers — click to pre-fill:",
    "providerIdPlaceholder": "Provider ID (e.g. my-llm-server)",
    "apiKeyOptionalPlaceholder": "API Key (optional)",
    "noSaved": "No saved providers yet",
    "noSavedHint": "Add a provider to get started",
    "apiKeysLabel": "API Keys",
    "addKey": "Add Key",
    "noKeys": "No keys configured",
    "active": "Active",
    "setActive": "Set Active",
    "keyLabelPlaceholder": "Key label (e.g. default, production)",
    "apiKeyPlaceholder": "API key",
    "saveKey": "Save Key",
    "savedToast": "Saved key for {{name}}"
  },
  "mcp": {
    "status": {
      "connected": "Connected",
      "connecting": "Connecting",
      "sleeping": "Sleeping",
      "discovering": "Discovering",
      "error": "Error",
      "stopped": "Stopped",
      "unknown": "Unknown"
    },
    "disabled": "MCP servers are disabled.",
    "wakeTitle": "Wake server",
    "sleepTitle": "Sleep server",
    "discoverTitle": "Discover tools",
    "editTitle": "Edit",
    "removeTitle": "Remove",
    "statusLabel": "Status:",
    "enabledLabel": "Enabled:",
    "yes": "Yes",
    "no": "No",
    "descriptionLabel": "Description:",
    "pidLabel": "PID:",
    "errorLabel": "Error:",
    "toolsLabel": "Tools ({{count}}):",
    "noTools": "No tools discovered yet",
    "serverNameRequired": "Server name is required",
    "dialogTitleEdit": "Edit MCP Server",
    "dialogTitleAdd": "Add MCP Server",
    "dialogTitleAddCustom": "Add Custom MCP Server",
    "fieldName": "Name",
    "fieldNamePlaceholder": "e.g., github, filesystem",
    "fieldTransport": "Transport",
    "fieldUrl": "URL",
    "fieldCommand": "Command",
    "fieldCommandPlaceholder": "e.g., npx",
    "fieldArgs": "Args",
    "fieldArgsHint": "(space-separated)",
    "fieldArgsPlaceholder": "e.g., -y @modelcontextprotocol/server-github",
    "fieldEnv": "Env vars",
    "fieldEnvHint": "(KEY=value, one per line)",
    "fieldDescription": "Description",
    "fieldDescriptionPlaceholder": "GitHub MCP server for repository access",
    "enableServer": "Enable server",
    "lazyConnect": "Lazy connect",
    "lazyConnectHint": "(don't start until first tool call; auto-sleeps when idle)",
    "saveChanges": "Save Changes",
    "addServer": "Add Server",
    "requires": "Requires: {{vars}}",
    "added": "Added",
    "heading": "MCP Servers",
    "summary": "{{connected}} connected · {{sleeping}} sleeping · {{total}} total",
    "addCustom": "Add Custom",
    "tabRecommended": "Recommended",
    "tabServers": "Servers",
    "tabAddCustom": "Add Custom",
    "recommendedBody": "One-click add for popular MCP servers. Click Add to pre-fill the configuration, then confirm. Servers requiring credentials will need their env vars set before use.",
    "loadingServers": "Loading servers...",
    "noServers": "No MCP servers configured",
    "noServersHint": "Switch to the Recommended tab to add popular servers, or Add Custom for your own.",
    "addCustomBody": "Configure a custom MCP server with stdio, SSE, or HTTP transport.",
    "addCustomBodyHint": "For popular servers, use the Recommended tab instead — everything is pre-configured for you.",
    "removeConfirmTitle": "Remove server \"{{name}}\"?",
    "removeConfirmBody": "This removes the MCP server from your configuration.",
    "toastAdded": "Server \"{{name}}\" added",
    "toastRemoved": "Server \"{{name}}\" removed",
    "toastDiscovered": "Discovered {{count}} tools from \"{{name}}\"",
    "toastSleeping": "Server \"{{name}}\" is now sleeping",
    "toastConnected": "Server \"{{name}}\" connected",
    "toastReconnected": "Server \"{{name}}\" reconnected",
    "toastDisconnected": "Server \"{{name}}\" disconnected: {{reason}}",
    "toastError": "Server \"{{name}}\" error: {{error}}",
    "disabledHint": "Enable the \"MCP servers\" feature flag in the Features tab to use this section."
  },
  "allowlist": {
    "title": "Clear saved allowlist?",
    "body_one": "This will remove the pinned model for {{provider}}. The model picker will fall back to the models.dev catalog.",
    "body_other": "This will remove the {{count}} pinned models for {{provider}}. The model picker will fall back to the models.dev catalog.",
    "undoHint": "You can undo this for 8 seconds after confirming.",
    "keepTitle": "Keep the allowlist (Esc)",
    "clearTitle": "Clear the allowlist (Enter)",
    "clear": "Clear allowlist"
  },
  "oauth": {
    "termsWarning": "Sign in with a subscription instead of an API key. Using a subscription outside its official client may violate the provider's Terms — your account could be rate-limited or banned. An API key is the sanctioned path for programmatic use.",
    "signIn": "Sign in",
    "waitingBrowser": "Waiting for you to sign in…",
    "openSignIn": "Open sign-in page",
    "pasteLoopbackBusy": "Loopback port busy — paste the redirect URL",
    "pasteCantReach": "Browser can't reach this server? Paste the redirect URL",
    "submit": "Submit",
    "enterCode": "Enter this code at the verification page:",
    "openVerification": "Open verification page",
    "waitingCode": "Waiting for authorization…",
    "exchanging": "Exchanging tokens…",
    "fetchingModels": "Fetching models…",
    "signedIn": "Signed in.",
    "signedInToast": "Signed in — {{provider}}",
    "signInFailed": "Sign-in failed"
  },
  "agent": {
    "modelHeading": "Model",
    "autonomyHeading": "Autonomy & Behavior",
    "autonomyModeLabel": "Autonomy mode",
    "autonomyModeHint": "How independently the agent proceeds between turns.",
    "autonomyModeOff": "Off — full manual control",
    "autonomyModeSuggest": "Suggest — suggests next steps",
    "autonomyModeAuto": "Auto — brief confirmation delay",
    "autonomyModeEternal": "Eternal — autonomous until goal done",
    "autonomyModeEternalParallel": "Eternal Parallel — multi-agent fleet",
    "autoProceedDelayLabel": "Auto-proceed delay",
    "autoProceedDelayHint": "Milliseconds before the agent auto-proceeds in Auto mode. 0 = immediate.",
    "yoloLabel": "YOLO mode",
    "yoloHint": "Bypass tool confirmation prompts — the agent runs without asking.",
    "refineHeading": "Prompt Refinement",
    "enableRefineLabel": "Enable refine",
    "enableRefineHint": "Rewrite prompts before sending — clearer instructions, better results.",
    "refineDelayLabel": "Refine delay",
    "refineDelayHint": "Countdown before the refined prompt auto-sends.",
    "refineLanguageLabel": "Refine language",
    "refineLanguageHint": "Keep your language or translate to English for the model.",
    "refineLanguageOriginal": "Original — keep your language",
    "refineLanguageEnglish": "English — translate to English",
    "reasoningHeading": "Reasoning & Cache",
    "reasoningModeLabel": "Reasoning mode",
    "reasoningModeHint": "Control how the model uses extended thinking. Auto = provider default.",
    "reasoningModeAuto": "Auto — provider default",
    "reasoningModeOn": "On — force thinking on",
    "reasoningModeOff": "Off — force thinking off",
    "reasoningEffortLabel": "Reasoning effort",
    "reasoningEffortHint": "How much compute the model spends thinking. Only sent when the model supports it.",
    "reasoningEffortNone": "None",
    "reasoningEffortMinimal": "Minimal",
    "reasoningEffortLow": "Low",
    "reasoningEffortMedium": "Medium",
    "reasoningEffortHigh": "High",
    "reasoningEffortXhigh": "Extra High",
    "reasoningEffortMax": "Max",
    "preserveThinkingLabel": "Preserve thinking",
    "preserveThinkingHint": "Keep reasoning blocks across turns for context continuity.",
    "cacheTtlLabel": "Cache TTL",
    "cacheTtlHint": "Prompt cache time-to-live. 1h costs more on write but saves on repeat reads (Anthropic).",
    "cacheTtlDefault": "Default — provider default",
    "cacheTtl5m": "5 minutes",
    "cacheTtl1h": "1 hour",
    "capsHint": "Use wstack models caps to check what the current model supports. Unsupported settings are silently omitted per-request.",
    "fallbackHeading": "Model Fallbacks",
    "fallbackBody": "When the active model rate-limits (429/529), 5xx-errors, or stalls — after its own retries — the agent rotates to the next model in this chain. Also used as the default for SDD worker subagents.",
    "autoFallbackLabel": "Auto fallback",
    "autoFallbackHint": "When the chain above is empty, auto-derive one from your keyed providers.",
    "favoritesOnlyLabel": "Favorites only",
    "favoritesOnlyHint": "When auto fallback derives a chain, restrict it to your favorite models.",
    "profilesHeading": "Fallback Profiles",
    "addProfile": "Add",
    "noProfiles": "No named fallback profiles yet.",
    "createDefault": "Create default from active model",
    "useChain": "Use chain",
    "setLeader": "Set leader",
    "profileEmpty": "Profile is empty.",
    "favoritesHeading": "Favorite Models",
    "favoritesEmpty": "Favorites are shown first and can constrain auto fallback.",
    "routingHeading": "Model Routing",
    "routingRouteKey": "Model route key",
    "routingPhasesGroup": "Phases",
    "routingRolesGroup": "{{label}} roles",
    "routingCustomGroup": "Custom existing routes",
    "routingTargetPlaceholder": "fallback1, provider/model, or blank",
    "routingSet": "Set",
    "routingReasoningModeAria": "New route reasoning mode",
    "routingReasoningEffortAria": "New route reasoning effort",
    "routingReasoningPreserveAria": "New route reasoning preserve",
    "routingReasoningModeFor": "Reasoning mode for {{key}}",
    "routingReasoningEffortFor": "Reasoning effort for {{key}}",
    "routingReasoningPreserveFor": "Reasoning preserve for {{key}}",
    "noRoutes": "No model routes yet.",
    "leaderModel": "leader model",
    "hqHeading": "HQ Client",
    "hqPublishingLabel": "HQ publishing",
    "hqPublishingHint": "Publish this WebUI/client session to WrongStack HQ. Same-machine clients can auto-discover local HQ auth; remote clients use the URL/token below.",
    "hqUrlLabel": "HQ URL",
    "hqUrlHint": "Leave empty for same-machine auto-discovery.",
    "hqTokenLabel": "HQ client token",
    "executionHeading": "Execution",
    "maxIterationsLabel": "Max iterations per run",
    "maxIterationsHint": "Hard cap on LLM turns per agent.run().",
    "autoProceedMaxIterationsLabel": "Auto-proceed max iterations",
    "autoProceedMaxIterationsHint": "Stop auto-proceed after N iterations. 0 = unlimited.",
    "confirmExitLabel": "Confirm before exit",
    "confirmExitHint": "First Ctrl+C aborts work, second confirms exit.",
    "chimeLabel": "Chime on completion",
    "chimeHint": "Terminal bell when an agent run finishes.",
    "fleetHeading": "Fleet & Streaming",
    "streamFleetLabel": "Stream fleet events",
    "streamFleetHint": "Show live subagent activity in the fleet panel.",
    "maxConcurrentLabel": "Max concurrent subagents",
    "maxConcurrentHint": "Maximum number of subagents that can run simultaneously.",
    "nextPredictionLabel": "Next-step prediction",
    "nextPredictionHint": "After a turn completes, predict likely next steps.",
    "telegramHeading": "Telegram Notifications",
    "telegramSessionEndLabel": "Session end",
    "telegramSessionEndHint": "Send a summary when a session ends.",
    "telegramDelegateLabel": "Delegate finished",
    "telegramDelegateHint": "Send a humanized note when a subagent completes.",
    "telegramLongToolLabel": "Long-running tools",
    "telegramLongToolHint": "Notify when a tool exceeds {{ms}}ms. Set 0 to disable.",
    "telegramChangesApply": "Changes apply immediately.",
    "telegramNotConfigured": "Telegram is not configured. Run /telegram-setup in the CLI to connect a bot first.",
    "addModelToProfile": "Add model to profile…",
    "addFavoriteModel": "Add favorite model…",
    "hqRawContentLabel": "Raw HQ content",
    "hqRawContentHint": "Send raw content previews to HQ instead of redacted previews."
  },
  "features": {
    "flagsHeading": "Feature Flags",
    "mcpLabel": "MCP servers",
    "mcpHint": "Enable Model Context Protocol integrations.",
    "pluginsLabel": "Plugins",
    "pluginsHint": "Load and run user-installed plugins.",
    "memoryLabel": "Memory",
    "memoryHint": "Persist and recall facts across sessions.",
    "skillsLabel": "Skills",
    "skillsHint": "Load domain-specific skill prompts.",
    "modelsRegistryLabel": "Models registry",
    "modelsRegistryHint": "Use the models.dev catalog for provider discovery.",
    "indexOnStartLabel": "Index on start",
    "indexOnStartHint": "Build the codebase symbol index at session start.",
    "contextHeading": "Context & Debug",
    "autoCompactLabel": "Auto-compact context",
    "autoCompactHint": "Automatically trim the context window when near limits.",
    "compactorStrategyLabel": "Compactor strategy",
    "compactorStrategyHint": "How the context is compacted when it grows too large.",
    "compactorStrategyHybrid": "Hybrid — fast rules (default)",
    "compactorStrategyIntelligent": "Intelligent — LLM summarization",
    "compactorStrategySelective": "Selective — LLM-driven selection",
    "contextModeLabel": "Context mode",
    "contextModeHint": "Context window policy — balanced is the default.",
    "contextModeBalanced": "Balanced — normal context usage",
    "contextModeFrugal": "Frugal — conservative token use",
    "contextModeDeep": "Deep — larger context for complex tasks",
    "contextModeArchival": "Archival — maximize context retention",
    "tokenSavingLabel": "Token-saving mode",
    "tokenSavingHint": "How aggressively to reduce token usage.",
    "tokenSavingOff": "Off — no token saving",
    "tokenSavingMinimal": "Minimal — basic optimization",
    "tokenSavingLight": "Light — moderate reduction",
    "tokenSavingMedium": "Medium — significant savings",
    "tokenSavingAggressive": "Aggressive — maximum compression",
    "logLevelLabel": "Log level",
    "logLevelHint": "Minimum severity for server-side logging.",
    "logLevelDebug": "Debug — everything",
    "logLevelInfo": "Info — normal flow",
    "logLevelWarn": "Warn — problems only",
    "logLevelError": "Error — failures only",
    "auditLevelLabel": "Audit level",
    "auditLevelHint": "Detail level for session audit logs.",
    "auditLevelMinimal": "Minimal — errors only",
    "auditLevelStandard": "Standard — tool calls + errors",
    "auditLevelFull": "Full — every event (large logs)"
  },
  "toast": {
    "switchingTo": "Switching to {{provider}} / {{model}}…",
    "fallbackExists": "Fallback profile \"{{name}}\" already exists",
    "selectProviderModelFirst": "Select a provider and model first",
    "defaultProfileCreated": "Default fallback profile created",
    "profileEmpty": "Fallback profile \"{{name}}\" is empty",
    "leaderSetFrom": "Leader set from {{name}}"
  }
}
